import { assign } from "lodash";
import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormGroup, FormControl } from '@angular/forms';
import * as FlatModels from "@medsurf/flat-models";
import * as FlatFacades from '@medsurf/flat-facades';
import { ZodSharedValidator } from "@medsurf/flat-validators";

@Component({
    selector: 'medsurf-slide-edit-free-form-pointer-form',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './free-form-pointer-form.component.html',
    styleUrls: ['./free-form-pointer-form.component.scss'],
    standalone: false
})
export class FreeFormPointerFormComponent {
  #isSubmitted = signal(false);
  #freeFormStyle: FlatModels.FreeFormStyleEntityModels.FreeFormStyle;
  freeFormStyleForm = new FormGroup(
    {
      startType: new FormControl(''),
      startRadius: new FormControl(0),
      endType: new FormControl(''),
      endRadius: new FormControl(0),
    },
    {
      validators: ZodSharedValidator.validate(
        FlatModels.FreeFormStyleEntityModels.FreeFormStyleSchema.pick({
          startType: true,
          startRadius: true,
          endType: true,
          endRadius: true,
        })
      )
    }
  );
  readonly FlatModels = FlatModels;
  
  constructor(public alertControlFacade: FlatFacades.AlertControlFacade,
              public slideAuthorFacade: FlatFacades.SlideAuthorFacade) {
    // Update Free Form Style
    this.slideAuthorFacade.currentSelectedSlideFreeFormStyle$.pipe(takeUntilDestroyed()).subscribe((freeFormStyle) => {
      this.#freeFormStyle = structuredClone(freeFormStyle);
      if (freeFormStyle) {
        this.freeFormStyleForm.reset(this.#freeFormStyle);
      }
      this.#isSubmitted.set(false);
    });
  }
  
  onSubmit() {
    if (this.#isSubmitted() || this.freeFormStyleForm.invalid) {
      return;
    }
    this.#isSubmitted.set(true);
    
    const freeFormStyle = assign(this.#freeFormStyle, this.freeFormStyleForm.value);
    this.slideAuthorFacade.requestUpdateFreeFormStyle(freeFormStyle, 'history.free_form_update_style').subscribe({
      error: (result) => {
        ZodSharedValidator.handleError(result, this.alertControlFacade, this.freeFormStyleForm);
        this.#isSubmitted.set(false);
      },
      next: () => {
        this.#isSubmitted.set(false);
      }
    });
  }
  
  onStartTypeChange() {
    if (this.freeFormStyleForm.value.startType === FlatModels.AnnotationEntityModels.TipType.enum.circle && (!this.freeFormStyleForm.value.startRadius || this.freeFormStyleForm.value.startRadius === 0)) {
      this.freeFormStyleForm.patchValue({startRadius: 20});
    }
    this.onSubmit();
  }
  
  onEndTypeChange() {
    if (this.freeFormStyleForm.value.endType === FlatModels.AnnotationEntityModels.TipType.enum.circle && (!this.freeFormStyleForm.value.endRadius || this.freeFormStyleForm.value.endRadius === 0)) {
      this.freeFormStyleForm.patchValue({endRadius: 20});
    }
    this.onSubmit();
  }
}
